import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// api
import * as school_v2API from 'api/school_v2';
import * as schoolTypes from 'types/school';

// ----------------------------------------------------------------------

type schoolBaseActivity = {
  loading: boolean;
  fullClassList: any[]; // Assuming this is an array of class objects
  yearList: {
    total: number; // Total number of years
    rows: any[]; // Assuming this is an array of year objects
  }; // Assuming this is an array of year objects
  classList: {
    total: number; // Total number of years
    rows: any[]; // Assuming this is an array of year objects
  }; // Assuming this is an array of year objects
};

const initialState: schoolBaseActivity = {
  loading: false,
  fullClassList: [],
  yearList: { total: -1, rows: [] },
  classList: { total: -1, rows: [] }
};

const slice = createSlice({
  name: 'school',
  initialState,
  reducers: {
    startLoading(state) {
      state.loading = true;
    },

    setFullClassList(state, action) {
      state.loading = false;
      state.fullClassList = action.payload;
    },
    setYearList(state, action) {
      state.loading = false;
      state.yearList = action.payload;
    },
    setClassList(state, action) {
      state.loading = false;
      state.classList = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------
// Actions
// export const { startLoading, setStepperFormData } = slice.actions;

// action

// 獲取新增校本課程題目
export function get_all_class_list(params: schoolTypes.get_all_class_list_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback } = params;
    try {
      const response = await school_v2API.get_all_class_list({});
      console.log(response);
      if (Array.isArray(response)) {
        dispatch(slice.actions.setFullClassList(response));
      }

      if (callback) {
        callback(response);
      }
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    }
  };
}

export function get_class_list(params: schoolTypes.get_class_list_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback, ...rest } = params;
    try {
      const response = await school_v2API.get_class_list(rest);
      console.log(response);

      if (callback) {
        callback(response);
      }

      dispatch(slice.actions.setClassList(response));
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    }
  };
}

export function get_year_list(params: schoolTypes.get_year_list_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback } = params;
    try {
      const response = await school_v2API.get_year_list({});
      console.log(response);

      dispatch(slice.actions.setYearList(response));

      if (callback) {
        callback(response);
      }
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    }
  };
}
